"use strict";
/**
 * @description 差异备份
 * @author fangzhicong
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var cache_1 = __importDefault(require("../../../../utils/data-structure/cache"));
var compile_1 = __importDefault(require("./compile"));
var decompilation_1 = require("./decompilation");
var NodeCache = /** @class */ (function (_super) {
    __extends(NodeCache, _super);
    function NodeCache(editor) {
        var _this = _super.call(this, editor.config.historyMaxSize) || this;
        _this.editor = editor;
        return _this;
    }
    NodeCache.prototype.observe = function () {
        this.resetMaxSize(this.editor.config.historyMaxSize);
    };
    /**
     * 编译并保存数据
     */
    NodeCache.prototype.compile = function (data) {
        this.save(compile_1.default(data));
        return this;
    };
    /**
     * 撤销
     */
    NodeCache.prototype.revoke = function () {
        return _super.prototype.revoke.call(this, function (data) {
            decompilation_1.revoke(data);
        });
    };
    /**
     * 恢复
     */
    NodeCache.prototype.restore = function () {
        return _super.prototype.restore.call(this, function (data) {
            decompilation_1.restore(data);
        });
    };
    return NodeCache;
}(cache_1.default));
exports.default = NodeCache;
